import React from 'react';
import { motion } from 'framer-motion';
export function StatsBar() {
  const stats = [{
    value: '+500',
    label: 'familias y docentes confían'
  }, {
    value: '6',
    label: 'Tomos listos'
  }, {
    value: '4.9/5',
    label: 'calificación ⭐'
  }, {
    value: '6',
    label: 'Bonos incluidos'
  }];
  return <div className="bg-navy-900/80 border-y border-navy-700/50 py-6" data-id="element-274">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-275">
        <div className="grid grid-cols-2 gap-4 md:grid-cols-4 md:gap-0 md:divide-x md:divide-navy-700/60" data-id="element-276">
          {stats.map((stat, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex items-center gap-2.5 justify-center md:px-4" data-id="element-277">
              <span className="text-xl md:text-3xl font-bold font-poppins text-white" data-id="element-278">
                {stat.value}
              </span>
              <span className="text-[11px] md:text-sm text-slate-400 font-medium leading-tight max-w-[90px]" data-id="element-279">
                {stat.label}
              </span>
            </motion.div>)}
        </div>
      </div>
    </div>;
}